import FieldFactory from './FieldFactory.js'

const VALID_TYPES = [
  'CENTURY',
  'DAY',
  'DECADE',
  'DOW',
  'DOY',
  'EPOCH',
  'HOUR',
  'ISODOW',
  'ISOYEAR',
  'MICROSECONDS',
  'MILLENNIUM',
  'MILLISECONDS',
  'MINUTE',
  'MONTH',
  'QUARTER',
  'SECOND',
  'TIMEZONE',
  'TIMEZONE_HOUR',
  'TIMEZONE_MINUTE',
  'WEEK',
  'YEAR'
]
const extractFromField = new RegExp( `^(?<unit>${VALID_TYPES.join( '|' )}) FROM (?<value>[a-zA-Z0-9, ._()*/+\\-:']+)$` )

export default {
  id : 'Expression.FieldParser.ExtractFromField',
  type : 'extractFromField',
  sort : 10,
  handles : ( field, context ) => {
    if ( field.type !== 'ExpressionParser.Field' ) {
      return false
    }

    const extractParent = findExtractRecursively( context.parent )

    return extractParent != null && field.value?.match( extractFromField )
  },
  parse : async ( field, context ) => {
    const { unit, value } = field.value.match( extractFromField ).groups
    return {
      type : 'ExpressionField.extractFrom',
      unit,
      value : ( await FieldFactory.create( value, context ) ).fields[0]
    }
  }
}

function findExtractRecursively( field ) {
  if ( field == null ) {
    return null
  }

  if ( field.type === 'ExpressionField.function' ) {
    return field
  }

  return findExtractRecursively( field.parent )
}
